import Amazon from './amazon'
import ContactForm from './contactForm'
import ContactInfo from './contactInfo'
import Copyright from './copyright'
import InvolvementPages from './involvementPages'
import MainPages from './mainPages'
import Social from './social'

export default ({ Amazon, ContactForm, ContactInfo, Copyright, InvolvementPages, MainPages, Social })